import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import "./Slider.scss";

export default function Sliders({
	step,
	min,
	max,
	marks,
	defaultValue,
	setday,
	settarget,
	value,
}) {
	return (
		<Box sx={{ width: 300 }}>
			<Slider
				defaultValue={defaultValue}
				onChange={(e) => {
					setday ? setday(e.target.value) : settarget(e.target.value);
				}}
				step={step}
				min={min}
				max={max}
				marks={marks}
				className="slider"
				aria-labelledby="discrete-slider-always"
				valueLabelDisplay="auto"
				value={value}
			/>
		</Box>
	);
}
